import { defineMessages } from 'react-intl';

export default defineMessages({
	subheading: {
		id: 'discountSignup.purchaseForm.preheading',
		defaultMessage: 'No commitment. Cancel anytime.',
		description: 'Signup flow payment subtitle',
	},
	trialHeading: {
		id: 'paymentForm.details.trial.heading',
		defaultMessage: 'Start your extended {br} 30-day free trial of Calm Premium.',
		description: 'Informing the user of the 30 day trial offer',
	},
	noTrialheading: {
		id: 'paymentForm.details.noTrial.heading',
		defaultMessage: 'Start your yearly plan of {br} Calm Premium.',
		description: 'Explaining the intent of the form',
	},
	heading: {
		id: 'paymentForm.details.heading',
		defaultMessage: 'Payment details',
		description: 'Heading for payment form',
	},
	modalCta: {
		id: 'paymentForm.details.cta',
		defaultMessage: 'Why now?',
		description: 'Text for payment modal cta',
	},
	todayOnly: {
		id: 'paymentForm.details.callout',
		defaultMessage: 'Today Only',
		description: 'To inform the offer is limited time',
	},
});
